// The backend can still serve pre-save labels right after a bulk save, so every
// post-bulk-create defect refetch waits this long before calling
// list-grouped-by-fileset.
export const DEFECT_REFETCH_DELAY_MS = 1000;
